const CHECKOUT_CHARGES = {
  greece: 1.5,
  cyprus: 3,
};

export default CHECKOUT_CHARGES;
